import { render, staticRenderFns } from "./Redirect.vue?vue&type=template&id=0f8d4e56&scoped=true&lang=html&"
import script from "./Redirect.vue?vue&type=script&lang=js&"
export * from "./Redirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8d4e56",
  null
  
)

export default component.exports